/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

import {
    Component,
    EventEmitter,
    Input,
    Output,
} from '@angular/core';

import { L10nService } from '@vmw/ngx-vip';
import * as globalL10n from 'global-l10n';
import * as l10n from './avi-fault-alert-modal.l10n';

import './avi-fault-alert-modal.component.less';

const { ...globalL10nKeys } = globalL10n;
const { ENGLISH: dictionary, ...l10nKeys } = l10n;

/**
 * @description Component to display fault alert messages.
 * @author Umesh Chovatiya
 */
@Component({
    selector: 'avi-fault-alert-modal',
    templateUrl: './avi-fault-alert-modal.component.html',
})
export class AviFaultAlertModalComponent {
    /**
     * Warning message(s) to be displayed.
     */
    @Input()
    public readonly details: string[];

    /**
     * To be fired on modal close.
     */
    @Output()
    public onClose = new EventEmitter<void>();

    /**
     * Function binding to close modal.
     */
    @Output()
    public closeModal = new EventEmitter<void>();

    /**
     * Get keys from source bundles for template usage
     */
    public readonly l10nKeys = l10nKeys;

    public readonly globalL10nKeys = globalL10nKeys;

    constructor(l10nService: L10nService) {
        l10nService.registerSourceBundles(dictionary);
    }

    /**
     * Dismisses alert modal.
     */
    public dismiss(): void {
        this.onClose.emit();
        this.closeModal.emit();
    }

    /**
     * Callback to ngFor-track by.
     */
    public trackbyIndex(index: number): number {
        return index;
    }
}
